import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '../../components/layout/PageContainer/PageContainer';
import { ConfiguredControls } from '../../components/features/ConfiguredControls/ConfiguredControls';
import { DemoControls } from '../../components/features/DeviceControl/DemoControls';
import { controlGroups } from '../../lib/rcu/query/grouping';
import { useRcuConfigStore } from '../../stores/rcuConfigStore';
import { heroImages } from '../../data/mockData';

/**
 * Guest controls. Once the technician has wired loads, the page shows them
 * grouped by room; until then it falls back to the demo devices so the tablet
 * is never empty.
 */
export const RoomControlsPage: React.FC = () => {
  const { t } = useTranslation();
  const config = useRcuConfigStore((state) => state.config);

  const groups = React.useMemo(() => controlGroups(config), [config]);
  const hasConfiguredLoads = groups.length > 0;

  return (
    <PageContainer
      heroImage={heroImages.roomControls}
      heroHeight="small"
      heroTitle={t('roomControls.title')}
      heroSubtitle={t('roomControls.subtitle')}
      overlayOpacity={0.45}
    >
      <div className="bg-white rounded-2xl p-6 shadow-[0_2px_8px_rgba(0,0,0,0.08)]">
        <h2 className="mb-6 font-display text-2xl text-[#333333]">
          {hasConfiguredLoads ? config.rcu.name || t('roomControls.title') : t('roomControls.demo')}
        </h2>

        {hasConfiguredLoads ? (
          <ConfiguredControls
            groups={groups}
            config={config}
            defaultRoomId={config.defaultRoomId}
          />
        ) : (
          <DemoControls />
        )}
      </div>
    </PageContainer>
  );
};

export default RoomControlsPage;
